import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-mypage',
  templateUrl: 'mypage.html'
})
export class MyPagePage {

  constructor(public navCtrl: NavController) {

  }

}



// WEBPACK FOOTER //
// ./src/pages/mypage/mypage.ts